import { render, staticRenderFns } from "./automaticRules.vue?vue&type=template&id=28df2dbe&scoped=true&"
import script from "./automaticRules.vue?vue&type=script&lang=js&"
export * from "./automaticRules.vue?vue&type=script&lang=js&"
import style0 from "./automaticRules.vue?vue&type=style&index=0&id=28df2dbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28df2dbe",
  null
  
)

export default component.exports